module.exports = __webpack_public_path__ + "img/34.992291e3.jpg";